import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { AnimalGroupsPage } from '@/pages/Administration/components/animalGroups/AnimalGroupsPage';
import { OrganizationCard } from '@/pages/Administration/components/organizations/card/OrganizationCard';
import { OrganizationsTable } from '@/pages/Administration/components/organizations/OrganizationsTable';
import { RoleCard } from '@/pages/Administration/components/roles/card/RoleCard';
import { RolesTable } from '@/pages/Administration/components/roles/RolesTable';
import { UserCard } from '@/pages/Administration/components/users/card/UserCard';
import { UsersTable } from '@/pages/Administration/components/users/UsersTable';
import { administration } from '@/shared/security/permissions/administration';

const LazyAdministration = lazy(() =>
  import('./AdministrationPage').then((module) => ({
    default: module.AdministrationPage,
  })),
);

const baseRoute: RouteObject = {
  path: '/administration',
  element: <Loading children={<LazyAdministration />} />,
  children: [],
};

const administrationRoutes = [
  {
    path: '/administration/users',
    element: (
      <Secured security={{ permissions: administration.users.viewList }}>
        <UsersTable />
      </Secured>
    ),
    index: true,
  },
  {
    path: '/administration/users/:id',
    element: (
      <Secured security={{ permissions: administration.users.view }}>
        <UserCard />
      </Secured>
    ),
  },
  {
    path: '/administration/roles',
    element: (
      <Secured security={{ permissions: administration.roles.viewList }}>
        <RolesTable />
      </Secured>
    ),
  },
  {
    path: '/administration/roles/:name',
    element: (
      <Secured security={{ permissions: administration.roles.view }}>
        <RoleCard />
      </Secured>
    ),
  },
  {
    path: '/administration/organizations',
    element: (
      <Secured security={{ permissions: administration.orgs.viewList }}>
        <OrganizationsTable />
      </Secured>
    ),
  },
  {
    path: '/administration/organizations/:id',
    element: (
      <Secured security={{ permissions: administration.orgs.view }}>
        <OrganizationCard />
      </Secured>
    ),
  },
  {
    path: '/administration/animal-groups',
    element: (
      <Secured security={{ permissions: administration.animalGroups.viewList }}>
        <AnimalGroupsPage />
      </Secured>
    ),
  },
];
baseRoute.children = [...administrationRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const AdministrationRoutes = routes;
